import React from "react";
import { translate } from "react-i18next";
import { connect } from "react-redux";
import { TextField } from "@material-ui/core";

class InputForm extends React.Component {
  onChange = (e) => {
    if (this.props.onChange) {
      // let value = e.target.value;
      // if (
      //   (this.props.type === "text" || !this.props.type) &&
      //   value &&
      //   typeof value === "string" &&
      //   !value.trim()
      // ) {
      //   e.target.value = value.trim();
      // }
      this.props.onChange(e);
    }
  };
  render() {
    const {
      children = "",
      disabled = false,
      InputProps = {},
      inputProps = {},
      margin = "none",
      fullWidth = true,
      variant = "outlined",
      useValue,
      value = "",
      t,
      tReady,
      ...props
    } = this.props;
    if (useValue) {
      return (
        <TextField
          {...props}
          onChange={this.onChange}
          value={value}
          disabled={Boolean(disabled)}
          variant={variant}
          fullWidth={fullWidth}
          margin={margin}
          InputProps={InputProps}
          inputProps={inputProps}
        >
          {children}
        </TextField>
      );
    } else {
      return (
        // Dành cho TH không thể gán state vào value để tránh render lại
        <TextField
          {...props}
          disabled={Boolean(disabled)}
          variant={variant}
          fullWidth={fullWidth}
          margin={margin}
          InputProps={InputProps}
        >
          {children}
        </TextField>
      );
    }
  }
}

InputForm.propTypes = {
  // onChange: PropTypes.func.isRequired,
};
InputForm.defaultProps = {
  useValue: true,
};
const mapState = (state) => ({});

const mapDispatch = (dispatch) => ({});

export default connect(
  mapState,
  mapDispatch
)(translate("translations")(InputForm));
